module.exports = __webpack_public_path__ + "static/media/bootstrap.e96af351.png";